import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const demio = defineConnector({
  identifier: "demio",
  name: "Demio",
  tagLine: "Webinar platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://my\\.demio\\.com/api/.*",
  auth: (app) =>
    headerAuth([
      { name: "Api-Key", value: app.secret.apiKey },
      { name: "Api-Secret", value: app.secret.apiSecret },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Demio](https://my.demio.com/), go to **Settings → API** to find your API key and API secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://my.demio.com/api/v1/events",
  },
});
